// UI MODULES
export enum routingActionType {
    list = 'list',
    create = 'create',
    edit = 'edit',
    details = 'details',
    info = 'information',
    quotesaccept = 'quotes-accept',
    copyquotes = 'copy-quotes',
    overview = 'overview',
    refund = 'refund',
    copyjobs = 'copy-jobs'
}
export enum routingInvoice {
    progress_invoice = 'progress-invoice',
    final_invoice = 'final'
}

export enum routingModuleType {
    authentication = 'authentication',
    dashboard = 'dashboard',
    interactions = 'interactions',
    collaboration = 'collaboration',
    supports = 'supports',
    business = 'business',
    organization = 'organization',
    features = 'features',
    accessdenied = 'access-denied',
    reports = 'reports',
    profile = 'profile'
}

export enum routingAuthenticationModuleType {
    signup = 'signup',
    validate_user = 'validate-user',
    signin = 'signin',
    forgot_password = 'forgot-password',
    reset_password = 'reset-password',
    user_organizations = 'user-organizations',
}

export enum routingDashboardModuleType {
    sales = 'sales',
    analytics = 'Analytical',
    saas = 'saas'
}

export enum routingInteractionsModuleType {
    clients = 'clients',
    contacts = 'contacts',
}

export enum routingInteractionsSubModuleType {
    contacts = 'contacts',
    notes = 'notes',
    jobs = 'jobs',
    quotes = 'quotes',
    invoices = 'invoices',
    documents = 'documents',
    expenses = 'expenses',
    custom_rates = 'custom-rates',
    timesheets = 'timesheets',
}

export enum routingCollaborationModuleType {
    jobs = 'jobs',
    timesheets = 'timesheet',
    timesheet_lock = 'timesheet-locking'
}

export enum routingCollaborationSubModuleType {
    all = 'all',
    my = 'my',
    archive = 'archive',
    notes = 'notes',
    timesheets = 'timesheets',
    expenses = 'expenses',
    financial = 'financial',
    job_task_info = 'job-task-info',
    job_time_info = 'job-time-info',
    job_notes_info = 'job-notes-info',
    today = 'today',
    job_todo = 'job-todo',
    thisweek = 'thisweek',
    engaged = 'engaged',
    rates = 'rates',
    phase = 'phases',
    milestones = 'milestones'
}

export enum routingBusinessModuleType {
    quotes = 'quotes',
    invoices = 'invoices',
    purchase_orders = 'purchase-orders',
    payments = 'payments',
    adjustments = 'adjustments',
    print = 'print',
    billing_history = 'billing-history'
}

export enum routingBusinessSubModuleType {
    invoices = "invoices/",
    invoice_job_charges = "invoice-job-charges/",
}

export enum routingBusinessSubModuleType {
    current = 'current',
    draft = 'draft',
    archive = 'archive',
    information = 'information',
    notes = 'notes',
    documents = 'documents',
    history = 'history',
    engaged = 'engaged',
    timesheets = 'timesheets',
    payments = 'payments',
    options = 'options',
    refund = 'refund',
    phase = 'phase',
    billing_history = 'billing history'
}

export enum routingOrganizerModuleType {
    organization = 'organization',
    features = 'features',
    connections = 'connections',
}

export enum routingOrganizationSubModuleType {
    settings = 'settings',
    number_sequences = 'number-sequences',
    client_types = 'client-types',
    quotes = 'quotes',
    quote_states = 'quote-states',
    jobs = 'jobs',
    job_setup = 'job-setup',
    job_settings = 'job-settings',
    clients = 'clients',
    staffs = 'staffs',
    teams = 'teams',
    tasks = 'tasks',
    expenses = 'expenses',
    costs = 'costs',
    csv_template = 'csv-template',
    custom_task_rates = 'custom-task-rates',
    job_category = 'job-category',
    job_states = 'job-states',
    job_template = 'job-template',
    custom_client_rate = 'custom-client-rates',
    custom_staff_rate = 'custom-staff-rates',
    task_historic_rates = 'task-historic-rates',
    roles = 'roles',
    login_history = 'login_history',
    access_permission = 'access_permission',
    rate_history = 'rate-history',
    organization_settings = 'organization-settings',
    system_settings = 'system-settings'
}

export enum routingFeaturesModuleType {
    customfields = 'custom-fields',
    emailtemplates = 'email-templates',
    customtemplates = 'custom-templates',
    invoicetemplates = 'invoice-templates',
}

export enum routingFeaturesSubModuleType {
    internal = 'internal',
    external = 'external',
    email_templates = 'email-templates',
    invoice_templates = 'invoice-templates'
}

export enum routingTemplatesSubModuleType {
    templates = 'templates',
    samples = 'samples',
}

// API MODULES
export enum moduleType {
    authentication = 'authentication/',
    dashboard = 'dashboard/',
    interactions = 'interactions/',
    collaboration = 'collaboration/',
    supports = 'supports/',
    business = 'business/',
    organizer_console = 'organization/',
    accessdenied = 'accessdenied/',
    reports = 'reports/',
    worksheet = 'worksheet/',
    features = 'features/'
}

export enum subModuleType {
    // authentication
    signup = 'signup/',
    organization_create = 'organization_create/',
    user_group = 'user_group/',
    validate_user = 'validate_user/',
    signin = 'signin/',
    token = 'token/',
    refresh = 'refresh/',
    signout = 'signout/',
    signout_all_device = 'signout_all_device/',
    reset_email = 'reset_email/',
    reset_password = 'reset_password/',
    change_password = 'change_password/',
    fire_base = 'fire_base/',
    subscribe_fcm = 'subscribe_push_notificaitons/',
    unsubscribe_fcm = 'unsubscribe_push_notificaitons/',
    organization = 'organization/',
    organization_selection = 'organization_selection/',
    get_user_organization_filter = 'get_user_organization_filter/',
    set_user_organization_filter = 'set_user_organization_filter/',
    user_login_history = 'user_login_history/',
    // app settings
    app_settings = 'get_app_settings_info/',

    // dashboard
    dashboard_data = 'dashboard_data/',
    dashboard_job = 'dashboard_job/',

    // notifications
    notification = 'notification/',
    notification_count = 'notification_count/',
    notification_read_all = 'notification_read_all',

    // interactions
    clients = 'client/',
    client = 'client/',
    contact = 'contact/',
    supplier = 'supplier/',
    client_list = 'client_list/',
    client_contact = 'client_contact/',
    client_notes = 'client_notes/',
    client_folders = 'client_folders/',
    client_folder_notes = 'client_folder_notes/',
    client_job = 'client_job/',
    client_quotes = 'client_quotes/',
    client_invoice = 'client_invoice/',
    client_document_upload = 'client_document_upload/',
    client_documents_folders = 'client_documents_folders/',
    client_documents_folders_documents = 'client_documents_folders_documents/',
    client_tasks_custom_rates = 'client_tasks_custom_rates/',
    client_custom_fields = 'client_custom_fields/',
    client_notes_comments = 'client_notes_comments/',
    supplier_contact = 'supplier_contact/',
    contacts = 'contacts/',
    supplier_notes = "supplier_notes/",
    supplier_cost = "supplier_cost/",
    supplier_folders = 'supplier_folders/',
    supplier_folder_notes = 'supplier_folder_notes/',
    supplier_po = 'supplier_po/',
    supplier_document_upload = 'supplier_document_upload/',
    supplier_documents_folders = 'supplier_documents_folders/',
    supplier_documents_folders_documents = 'supplier_documents_folders_documents/',
    address_type = 'address_type/',
    client_address = 'client_address/',
    client_overview = 'client_overview/',
    client_overview_count = 'client_overview_count/',
    client_payment_detail = 'client_payment_detail/',
    client_staff_billing_rates = 'client_staff_billing_rates/',
    client_task_billing_rates = 'client_task_billing_rates/',
    client_contact_custom_fields = 'client_contact_custom_fields/',
    // collaboration
    job = "job/",
    jobs = 'jobs/',
    jobstask = 'job_task/',
    timesheets = 'timesheets/',
    jobstates = 'job_states/',
    job_priority = 'job_priority/',
    jobtasktodo = 'job_task_todo/',
    jobtimesheet = 'timesheet/',
    job_staffs = 'job_staffs/',
    timesheet = 'timesheet/',
    job_cost = 'job_cost/',
    job_task_ddl = 'job_task/',
    job_notes_comments = 'job_notes_comments/',
    job_task_notes_comments = 'job_task_notes_comments/',
    job_quotes = 'job_quotes/',
    invoice = 'invoice/',
    job_po = 'job_po/',
    job_staff_task = 'job_staff_task/',
    job_task_staff = 'job_task_staff/',
    job_states_type = 'job_states_type/',
    job_document_upload = 'job_document_upload/',
    job_documents_folders = 'job_documents_folders/',
    job_documents_folders_documents = 'job_documents_folders_documents/',
    job_notes = 'job_notes/',
    job_folders = 'job_folders/',
    job_folder_notes = 'job_folder_notes/',
    job_task_notes = 'job_task_notes/',
    job_task_folders = 'job_task_folders/',
    job_task_folder_notes = 'job_task_folder_notes/',
    job_task = 'job_task/',
    job_financial_summary = 'job_financial_summary/',
    job_count = 'job_count/',
    job_history = 'job_history/',
    job_custom_fields = 'job_custom_fields/',
    multiple_job_delete = 'multiple_job_delete/',
    multiple_job_task_delete = 'multiple_job_task_delete/',
    multiple_job_cost_delete = 'multiple_job_cost_delete/',
    multiple_timesheet_delete = 'multiple_timesheet_delete/',
    multiple_job_task_todo_delete = 'multiple_job_task_todo_delete/',
    job_task_reorder = 'job_task_reorder/',
    job_cost_reorder = 'job_cost_reorder/',
    job_staff_billing_rates = "job_staff_billing_rates/",
    timesheet_status_update = "timesheet_status_update/",
    job_cost_status_update = "job_cost_status_update/",
    timesheet_status = 'timesheet_status/',
    timesheet_custom_fields = 'timesheet_custom_fields/',
    job_phase = 'job_phase/',
    job_milestones = 'job_milestones/',
    cost_sell_type = 'cost_sell_type/',
    job_phase_notes = 'job_phase_notes/',
    job_task_staff_allocation = 'job_task_staff_allocation/',
    due_creteria = 'due_creteria/',
    job_phase_items = 'job_phase_items/',
    job_task_custom_fields = 'job_task_custom_fields/',
    job_cost_custom_fields = 'job_cost_custom_fields/',
    invoice_jobs = 'invoice_jobs/',

    // version-2
    v2 = 'v2/',
    invoice_items = 'invoice_items/',

    // business
    quotes = 'quotes/',
    tax = 'tax/',
    quotes_types = 'quotes_types/',
    quotes_cost = 'quotes_cost/',
    quotes_cost_multi = 'quotes_multiple_cost/',
    quotes_cost_margin = 'quotes_multiple_cost_margin/',
    quotes_option_margin = 'quotes_multiple_options_margin/',
    quotes_options = 'quotes_options/',
    quotes_task = 'quotes_task/',
    quotes_multiple_task = 'quotes_multiple_task/',
    quotes_notes = 'quotes_notes/',
    quotes_folders = 'quotes_folders/',
    quotes_folder_notes = 'quotes_folder_notes/',
    quotes_history = 'quotes_history/',
    quotes_accept_info = 'quotes_accept_info/',
    quotes_archive = 'quotes/',
    quotes_document_upload = 'quotes_document_upload/',
    quotes_documents_folders = 'quotes_documents_folders/',
    quotes_documents_folders_documents = 'quotes_documents_folders_documents/',
    quotes_states = 'quotes_states/',
    quotes_notes_comments = 'quotes_notes_comments/',
    quotes_issue_and_accept = 'quotes_issue_and_accept/',
    quotes_custom_fields = 'quotes_custom_fields/',
    quotes_count = 'quotes_count/',
    quotes_option_task = 'quotes_option_task/',
    quotes_option_cost = 'quotes_option_cost/',
    multiple_quotes_delete = 'multiple_quotes_delete/',
    multiple_quotes_task_delete = 'multiple_quotes_task_delete/',
    multiple_quotes_expense_delete = 'multiple_quotes_cost_delete/',
    quotes_task_reoder = 'quotes_task_reoder/',
    quotes_cost_reoder = 'quotes_cost_reoder/',
    send_email = 'send_email/',
    email_with_attachment = 'email_with_attachment/',
    client_payment_transaction = 'client_payment_transaction/',
    invoice_payment_mode = 'invoice_payment_mode/',
    invoice_payment_transaction = 'invoice_payment_transaction/',
    invoice_adjustment_transaction = 'invoice_adjustment_transaction/',
    invoice_refund_transaction = 'invoice_refund_transaction/',
    quotes_phase = 'quotes_phase/',
    quotes_phase_items = 'quotes_phase_items/',
    quotes_rate_source = 'quotes_rate_source/',
    multiple_quotes_rate_source = 'multiple_quotes_rate_source/',
    quotes_phase_notes = 'quotes_phase_notes/',
    quotes_staff_rate_source = 'quotes_staff_rate_source/',
    quotes_task_staff_allocation = 'quotes_task_staff_allocation/',
    billing_history = 'billing_history/',

    // organizer-console
    staff = 'staff/',
    staff_task_billing_rates = 'staff_task_billing_rates/',
    staff_rate_history = 'staff_rate_history/',
    multiple_staff_history_delete = 'multiple_staff_history_delete/',
    task = 'task/',
    multiple_task_delete = 'multiple_task_delete/',
    team = 'team/',
    userprofile = 'userprofile/',
    balance_month = 'balance_month/',
    business_structure = 'business_structure/',
    client_type = 'client_type/',
    organization_settings = "organization_settings/",
    settings_dropdown = "settings/",
    time_zone = "timezone/",
    cost = 'cost/',
    cost_type = 'cost_type/',
    uplift_margin = "uplift_margin/",
    number_sequence = 'number_sequence/',
    group_task = 'group_task/',
    payment_terms = "payment_terms",
    tax_on_iq = "tax_on_invoice_quote",
    tax_on_po = "tax_on_po",
    job_settings = 'job_settings/',
    job_category = 'job_category/',
    job_states = 'job_states/',
    staff_custom_rates = 'staff_task_custom_rates/',
    user_access_permission = 'user_access_permission/',
    staff_access_permission = 'staff_access_permission/',
    client_access_permission = 'client_access_permission/',
    task_client_custom_rates = 'task_client_custom_rates/',
    task_staff_custom_rates = 'task_staff_custom_rates/',
    task_staff_billing_rates = 'task_staff_billing_rates/',
    task_client_billing_rates = 'task_client_billing_rates/',
    custom_field_type = "custom_field_type/",
    custom_field_usage = "custom_field_usage/",
    custom_field = 'custom_field/',
    job_template = 'job_template/',
    job_template_task = 'job_template_task/',
    job_template_cost = 'job_template_cost/',
    states = 'states/',
    country = 'country/',
    quotes_state = 'quotes-state',
    default_quotes_states_colors = 'default_quotes_states_colors/',
    default_job_states_colors = 'default_job_states_colors/',
    currency = 'currency/',
    round_unit_price = 'round_unit_price/',
    email_template_types = 'email_template_types/',
    template_type_variable = 'template_type_variable/',
    external_email_template = 'external_email_template/',
    internal_email_template = 'internal_email_template/',
    email_template = 'email_template/',
    multiple_client_type_delete = 'multiple_client_type_delete/',
    multiple_cost_delete = 'multiple_cost_delete/',
    multiple_job_category_delete = 'multiple_job_category_delete/',
    multiple_job_states_delete = 'multiple_job_states_delete/',
    multiple_job_template_delete = 'multiple_job_template_delete/',
    multiple_job_template_task_delete = 'multiple_job_template_task_delete/',
    multiple_job_template_cost_delete = 'multiple_job_template_cost_delete/',
    job_template_task_reoder = 'job_template_task_reoder/',
    job_template_cost_reoder = 'job_template_cost_reoder/',
    multi_approval_level = 'multi_approval_level/',
    user_multi_approval_level = 'user_multi_approval_level/',
    timesheet_rate_source = 'timesheet_rate_source/',

    multiple_job_template_phase_delete = 'multiple_job_template_phase_delete/',
    multiple_job_template_milestone_delete = 'multiple_job_template_milestone_delete/',

    job_template_phase_reorder = 'job_template_phase_reorder/',
    job_template_milestone_reorder = 'job_template_milestone_reorder/',
    job_template_phase = 'job_template_phase/',
    job_template_milestone = 'job_template_milestone/',
    staff_resend_email_invitation = 'invitation_resend/',

    organization_detail = 'organization_detail/',

    //role
    roles = 'roles/',
    privileges = 'privileges/',
    multiple_roles_delete = 'multiple_roles_delete/',

    //invoice
    invoices = 'invoice/',
    invoice_job_charges = 'invoice_job_charges/',
    invoice_charges = 'invoice_charges/',
    invoice_list = 'invoice_list/',
    ddl = 'ddl/',
    app = 'app',
    invoice_notes = 'invoice_notes/',
    invoice_folders = 'invoice_folders/',
    invoice_folder_notes = 'invoice_folder_notes/',
    invoice_task = 'invoice_task/',
    invoice_cost = 'invoice_cost/',
    invoice_payment = 'invoice_payment/',
    invoice_due = 'invoice_due/',
    invoice_timesheet = 'invoice_timesheet/',
    invoice_notes_comments = 'invoice_notes_comments/',
    invoice_sub_type_list = 'invoice_sub_type_list/',
    invoice_quotes_amount = 'invoice_quotes_amount/',
    invoice_overview = 'invoice_overview/',
    invoice_payment_write_off = 'invoice_payment_write_off/',
    miscellaneous_invoice = 'miscellaneous_invoice/',
    invoice_custom_fields = 'invoice_custom_fields/',
    invoice_task_reorder = 'invoice_task_reorder/',
    invoice_cost_reorder = 'invoice_cost_reorder/',
    invoice_charges_reorder = 'invoice_charges_reorder/',
    multiple_invoice_task_delete = 'multiple_invoice_task_delete/',
    multiple_invoice_cost_delete = 'multiple_invoice_cost_delete/',
    client_based_job = 'client_based_job/',
    invoice_blob = 'invoice_blob/',
    default_custom_templates = 'default_custom_templates/',
    //weekly-timesheet
    weekly_timesheet = 'weekly_timesheet/',
    timesheet_rate = 'timesheet_rate/',
    //timelock-period
    timesheet_locking = 'timesheet_locking/',
    timesheet_locking_staff_delete = 'timesheet_locking_staff_delete/',
    //features
    multiple_custom_field_delete = 'multiple_custom_field_delete/',
    multiple_external_email_templates_delete = 'multiple_external_email_templates_delete/',
    multiple_email_templates_delete = 'multiple_email_templates_delete/',
    invoice_image_upload = 'invoice_image_upload/',
    invoice_logo = 'invoice_logo/',
    invoice_image_delete_file = 'invoice_image_delete_file/',
    custom_templates = 'custom_templates/',
    invoice_settings = 'invoice_settings/',
    custom_template_pdf_view = 'custom_template_pdf_view/'

}